/**
 * @file impersonation-reason.ts
 * @description Правило причины входа под сотрудником (phase19.28 этап А;
 * PL17): обязательна, 5–300 знаков — как проверяет API
 * (`impersonation_reason_required` / `impersonation_reason_too_long`).
 */

export const IMPERSONATION_REASON_MIN = 5;
export const IMPERSONATION_REASON_MAX = 300;

/** Причина как её сохранит сервер: пробелы схлопнуты, по краям обрезаны. */
export function normalizeImpersonationReason(reason: string): string {
  return reason.replace(/\s+/g, " ").trim();
}

/** Что не так с причиной; null — годится. */
export function impersonationReasonIssue(reason: string): string | null {
  const length = normalizeImpersonationReason(reason).length;
  if (length === 0) return "Укажите причину входа — она попадёт в журнал магазина и платформы";
  if (length < IMPERSONATION_REASON_MIN) return `Причина — не короче ${IMPERSONATION_REASON_MIN} знаков`;
  if (length > IMPERSONATION_REASON_MAX) return `Причина — не длиннее ${IMPERSONATION_REASON_MAX} знаков`;
  return null;
}
